/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Indietro',
    BACK_TO_SEARCH: 'Torna alla ricerca',
    CANCEL: 'Annullare',
    CANCEL_DELIVERY_REQUEST: 'Annullare richiesta',
    CHANGE_DAY: 'Modificare giorno',
    CHANGE_LOCATION: 'Modificare posizione',
    CLICK_TO_EXPAND: 'Clicca o scorri per espandere',
    COLLECT_PIN: 'PIN per il ritiro',
    CONFIRM: 'Confermare',
    CURRENT_LOCATION: 'Utilizzare posizione attuale',
    EDIT_PIN: 'Modificare segnaposto',
    HELP_US_IMPROVE: 'Aiutaci a migliorare',
    LEAVE: 'uscire',
    NEW_SEARCH: 'Nuova ricerca',
    PICK_UP_PIN: 'PIN per il ritiro',
    PICK_UP_POINT: 'Punto di ritiro',
    SAME_LOCATION: 'Stessa posizione',
    SCAN_QR_CODE: 'Leggere ',
    SEARCH: 'Cercare',
    SIGN_IN: 'Accedere per modificare la richiesta di ordine',
    SIGN_IN_FOR_EVALUATION: 'Accedere per aiutarci a migliorare',
    SWIPE_DOWN: 'Scorri verso il basso per nascondere i dettagli',
    SWIPE_UP: 'Scorri verso l\'alto per vedere i dettagli'
  },
  ERRORS: {
    SERVICE_POINT_DOES_NOT_ACCEPT_COLLECTS:
      'Il punto di servizio non dispone di servizio di ritiro!',
    SERVICE_POINT_DOES_NOT_ACCEPT_ICE:
      'Il punto di servizio non accetta ordini con prodotti surgelati!',
    SERVICE_POINT_DOES_NOT_HAVE_CAPACITY:
      'Il punto di servizio ha raggiunto la capacità massima di ordini!',
    SOMETHING_WENT_WRONG: 'Si è verificato un errore, riprova più tardi.',
    ZIP_CODE_WRONG_FORMAT: 'formato C.A.P. invalido'
  },
  LABELS: {
    CURRENT: 'da',
    DELETE_MESSAGE: 'Elimina messaggio!',
    ERROR: 'Errore',
    NEW: 'per',
    NEW_ADDRESS: 'Nuovo indirizzo',
    OR: 'O',
    ORIGINAL_ADDRESS: 'Indirizzo originale',
    PICK_UP_POINT: 'Punto di ritiro',
    REQUIRES_CONFIRMATION: 'Modifica in attesa di conferma',
    SAME_DAY_COLLECT: 'Ritiro in giornata',
    SAME_DAY_DELIVERY: 'Consegna in giornata',
    SCHEDULE: 'Orario',
    SEARCH_LOCATION: 'Cerca indirizzo'
  },
  MESSAGES: {
    ADICIONAL_ADDRESS: 'Indirizzo aggiuntivo',
    ADJUST_PIN: 'Modifica segnaposto',
    BUILDING_DOOR_NUMBER: 'Numero civico',
    CALL_US: 'chiamaci',
    CHANGE_ADDRESS: 'Modificare indirizzo',
    CHANGE_ADDRESS_AUTOMATIC_COLLECT:
      'L\'indirizzo della richiesta di ritiro è stato modificato.',
    CHANGE_ADDRESS_AUTOMATIC_DELIVERY:
      'L\'indirizzo di consegna è stato modificato.',
    CHANGE_ADDRESS_TO_PICK_UP: 'Modifica indirizzo del punto di ritiro',
    CHANGE_COLLECT: 'Modifica ritiro',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_COLLECT:
      'Il giorno e l\'indirizzo della richiesta di ritiro sono stati modificati.',
    CHANGE_DATE_AND_ADDRESS_AUTOMATIC_DELIVERY:
      'Il giorno e l\'indirizzo di consegna dell\'ordine sono stati modificati.',
    CHANGE_DATE_AUTOMATIC_COLLECT:
      'Il giorno di richiesta di ritiro è stato modificato.',
    CHANGE_DATE_AUTOMATIC_DELIVERY:
      'Il giorno di consegna dell\'ordine è stato modificato.',
    CHANGE_DAY: 'Modificare giorno',
    CHANGE_DELIVERY: 'Modificare consegna',
    CHAT_TITLE: 'Messaggi',
    CITY: 'Città',
    CLIENT_REQUEST_TYPE: 'Tipo di richiesta',
    CONFIRM_DELETE_MESSAGE: 'Sei sicuro di volere eliminare questo messaggio?',
    CURRENT_COORDINATES: 'Coordinate attuali',
    CUSTOMER_SUPPORT: 'assistenza clienti',
    DATE: 'Data',
    DELETE_MESSAGE_NOW_ERROR:
      'Il messaggio non può essere eliminato perché è già stato letto da NOW.',
    DELETED_MESSAGE: 'Questo messaggio è stato eliminato',
    DELIVERY_HISTORY: 'Storico',
    DETAIL: 'Dettagli',
    DOOR_NUMBER: 'Numero civico',
    FILL_SEARCH_FIELDS:
      'Si prega di compilare i campi: via, numero civico, C.A.P. e città',
    FROM: 'Da:',
    HOUR: 'Ora',
    INVALID_TRACKING: 'Numero di tracciamento non valido',
    LOCATION_PREFERENCE: 'Preferenza di posizione',
    MANDATORY_FIELD: 'Campo obbligatorio',
    MAX_CHARACTERS: 'Massimo {max} caratteri.',
    MESSAGE: 'Messaggio',
    MESSAGES: 'Messaggi',
    NEW_MESSAGE: 'Nuovo messaggio',
    OBSERVATIONS: 'Osservazioni',
    REQUEST_APROVED: 'Richiesta accettata',
    REQUEST_CANCEL_TITLE: 'Cancella richiesta',
    REQUEST_CHANGE_ADDRESS: 'Richiesta di modifica indirizzo',
    REQUEST_CHANGE_DATE: 'Richiesta di modifica data',
    REQUEST_CHANGE_DATE_AND_ADDRESS: 'Richiesta di modifica data e indirizzo',
    REQUEST_CONTACT: 'Richiesta di contatto',
    REQUEST_CONTACT_TITLE: 'Richiedere contatto',
    REQUEST_MESSAGE: 'Richiesta di messaggio',
    REQUEST_REJECTED: 'Richiesta rifiutata',
    SEARCH_ADDRESS: 'Ricerca indirizzo',
    SEND_MESSAGE: 'Nuovo messaggio',
    STATUS: 'Stato',
    STATUS_CANCELED: 'Annullato',
    STATUS_PENDING_TREATMENT: 'In sospeso',
    STATUS_REJECTED: 'Rifiutato',
    STATUS_TREATED: 'Approvato',
    STREET: 'Via',
    TO: 'Per:',
    TYPE_MESSAGE: 'Scrivi il tuo messaggio...',
    ZIP_CODE: 'C.A.P.'
  },
  SENTENCES: {
    ADDRESS_NOT_FOUND: 'Indirizzo non trovato 😞, si prega di riprovare.',
    CONFIRM_CHANGE:
      'La tua richiesta è stata inoltrata con successo. Analizzeremo il modo migliore per aiutarti 🙂.',
    CONFIRM_CHANGE_AUTOMATIC:
      'La tua richiesta è stata accettata con successo 🙂.',
    CONFIRM_ERROR: 'C\'è stato un errore. Si prega di riprovare più tardi.',
    COORDINATES_NOT_FOUND:
      'Non sono state trovate coordinate per l\'indirizzo scelto.',
    DELIVERY_REQUEST_FAIL: 'Errore nella cancellazione della richiesta!',
    INVALID_DESTINATION: 'Indirizzo di destinazione non valido!',
    MAXIMUM_CONTACT_REQUESTS:
      'Puoi fare massimo {total} richieste di contatto.',
    MAXIMUM_REACHED: 'È stato raggiunto il numero massimo di richieste!',
    MAXIMUM_REQUESTS: 'Puoi fare massimo {total} richieste di modifica.',
    MAXIMUM_REQUESTS_LEFT: 'Mancano {left}.',
    NOT_FOUND: 'Non è stato possibile trovare ciò che cerchi.',
    NUMBER_OF_PACKAGES: '(composta da {total} scatole)',
    OUT_OF_RANGE:
      'L\'indirizzo che stai cercando di inserire è fuori dalla zona coperta da NOW. Per effettuare questa modifica, contatta il nostro {support}.',
    PICK_UP_NOT_FOUND:
      'Non è stato possibile trovare un punto di ritiro 😞, riprova.',
    REQUEST_CANCEL_DESCRIPTION:
      'Sei sicuro di voler annullare l\'ordine di modifica?',
    REQUEST_CHANGE_APPROVED: 'Il tuo {type} è stato accettato.',
    REQUEST_CHANGE_REJECTED: 'Il tuo {type} non è stato accettato.',
    REQUEST_CONTACT_APPROVED: 'Risponderemo al tuo {type}.',
    REQUEST_CONTACT_DESCRIPTION:
      'Una volta confermato, entreremo in contatto con te appena possibile 🙂.',
    REQUEST_CONTACT_EVALUATION:
      'Esiste una richiesta di contatto in sospeso. Entreremo in contatto con te a breve. Grazie.',
    REQUEST_CONTACT_REJECTED: 'Non sarà possibile rispondere al tuo {type}.',
    REQUEST_CONTACT_SUBMITTED:
      'La tua richiesta è stata inviata con successo. Verrai contattato da qualcuno di PROZIS NOW il prima possibile 🙂.',
    SHOW_COLLECT_QR_CODE:
      'Mostra questo codice nel punto di ritiro per poter consegnare ciò che verrà ritirato.',
    SHOW_DELIVERY_QR_CODE:
      'Mostra questo codice nel punto di ritiro per poter ritirare il tuo ordine.',
    STATUS_COLLECT_FAKE_PROCESSING:
      'La tua richiesta di ritiro verrà elaborata entro il {date}. Grazie 😉.',
    STATUS_COLLECT_IN_INTERRUPTED_ROUTE:
      'la rotta è attualmente interrotta a causa di problemi tecnici, la tua richiesta sarà ripresa il prima possibile.',
    STATUS_COLLECT_IN_ROUTING:
      'Stiamo arrivando. La tua richiesta di ritiro verrà realizzata tra le {from} e le {to} da {driver}. Ci siamo quasi😉.',
    STATUS_COLLECT_IN_SERVICE_POINT:
      'stiamo aspettando che tu posizioni ciò che vuoi che sia ritirato nel {name}.',
    STATUS_COLLECT_ON_THE_WAY_TO_SERVICE_POINT:
      'Stiamo arrivando. La tua richiesta di ritiro verrà realizzata tra le {from} e le {to} da {driver} nel punto di ritiro {name}. Ci siamo quasi😉.',
    STATUS_COLLECT_PROCESSING:
      'La tua richiesta di ritiro è stata già elaborata il giorno {date} alle {hour}. Ci siamo quasi😉.',
    STATUS_COLLECT_SUCCESS:
      'Il tuo ordine è stato ritirato da {driver} il giorno {date} alle {hour}. Se qualcosa non torna, {support}.',
    STATUS_COLLECT_UNSUCCESS:
      '{driver} non è riuscito a ritirare il tuo ordine.',
    STATUS_COLLECTED_SERVICE_POINT:
      'Il tuo ordine è stato ritirato dal {pickUp} il giorno {date} alle {hour}.',
    STATUS_DELIVERED_SERVICE_POINT:
      'Il tuo ordine {packages} è stato ritirato dal punto di ritiro {pickUp} il giorno {date} alle {hour}.',
    STATUS_DELIVERY_FAKE_PROCESSING:
      'il tuo ordine verrà elaborato entro il {date}. Grazie 😉.',
    STATUS_DELIVERY_IN_INTERRUPTED_ROUTE:
      'la rotta è attualmente interrotta a causa di problemi tecnici, la tua richiesta sarà ripresa il prima possibile.',
    STATUS_DELIVERY_IN_ROUTING:
      'il tuo ordine {packages} è in arrivo e verrà consegnato tra le {from} e le {to} da {driver}. Ci siamo quasi 😉.',
    STATUS_DELIVERY_IN_SERVICE_POINT:
      'il tuo ordine {packages} è disponibile per essere ritirato nel punto di ritiro {name}.',
    STATUS_DELIVERY_IN_SERVICE_POINT_UNTIL:
      'Hai fino al giorno {date} per ritirare il tuo ordine {packages}.',
    STATUS_DELIVERY_ON_THE_WAY_TO_SERVICE_POINT:
      'il tuo ordine {packages} sta arrivando e verrà consegnato tra le {from} e le {to} da {driver} nel punto di ritiro {name}. Ci siamo quasi 😉.',
    STATUS_DELIVERY_PROCESSING:
      'il tuo ordine {packages} è stato elaborato il giorno {date} alle {hour} e si trova nel centro di distribuzione: {location}. Ci siamo quasi 😉.',
    STATUS_DELIVERY_SUCCESS:
      'il tuo ordine {packages} è stato consegnato da {driver} il giorno {date} alle ore {hour}. Se qualcosa non va, {support}.',
    STATUS_DELIVERY_UNSUCCESS: '{driver} non è riuscito a consegnare l\'ordine.',
    STATUS_HELLO: '👋 Ciao, {name},',
    UPDATING_CHANGE: 'Stiamo aggiornando la tua richiesta 🙂',
    WARNING_DELIVERY_DELAY:
      'Avviso: siamo in ritardo con le consegne. Per maggiori informazioni, contatta {support}.',
    WARNING_REDUCED_EXPIRATION_DATE:
      'Attenzione: l\'ordine contiene uno o più articoli con una data di validità ridotta, che scadono il {date}. Vuoi continuare?'
  }
};
